import * as React from 'react';

import styled from 'styled-components';
import * as times from 'lodash/times';
import * as isNil from 'lodash/isNil';

import { COLOURS } from '../../../consts/style';

const SIZE = 20;

const Star = styled.div<{ clipRight: number }>`
  font-size: ${SIZE}px;
  width: ${SIZE}px;
  height: ${SIZE}px;
  line-height: 24px;
  position: relative;

  &:after {
    content: '★';
    color: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    ${(props) => {
      if (!isNil(props.clipRight)) {
        return `clip: rect(0, ${Math.round(props.clipRight * SIZE)}px, ${SIZE}px, 0);`;
      }
    }}
  }
`;

const Stars = styled.div`
  display: flex;
`;

export interface IStarRatingProps {
  rating: number;
  className?: string;
}

export const StarRating = ({ rating, ...props }: IStarRatingProps) => {
  const numFullStars = Math.floor(rating);
  const partial = rating % 1;
  return (
    <Stars {...props} data-id="star-rating">
      {times(5, (i) => {
        let clipRight = 100;
        if (i === numFullStars) {
          clipRight = partial;
        } else if (i > numFullStars) {
          clipRight = 0;
        }

        return <Star clipRight={clipRight} key={i} />;
      })}
    </Stars>
  );
};
